import 'styles/spinner';

import ploneApi from "api/PloneApi";

const Spinner = ({children, ...props}) => (
    <div className={ "spinner-blend" + (props.inline && "-inline" || "-absolute") }>
        <div className="cssload-loader">
            <div className="cssload-ball"></div>
        </div>
    </div>
);

export default Spinner;


// WEBPACK FOOTER //
// ./components/Spinner.jsx